module.exports = __webpack_public_path__ + "assets/img/noCaptch-light.76c6dd29.png";